import React from 'react';
import { Badge, ListGroup } from 'react-bootstrap';
import { OperationCode } from '../../auth/types';

export interface ActivityItem {
  id: string;
  title: string;
  description: string;
  role: OperationCode | string;
  timeAgo: string;
}

interface ActivityListProps {
  items: ActivityItem[];
}

export const ActivityList: React.FC<ActivityListProps> = ({ items }) => (
  <ListGroup variant="flush">
    {items.map((item) => (
      <ListGroup.Item key={item.id} className="py-3">
        <div className="d-flex justify-content-between">
          <div>
            <h6 className="mb-1">{item.title}</h6>
            <p className="mb-1 text-muted">{item.description}</p>
          </div>
          <div className="text-end">
            <Badge bg="info" className="mb-1">
              {item.role}
            </Badge>
            <div className="text-muted small">{item.timeAgo}</div>
          </div>
        </div>
      </ListGroup.Item>
    ))}
  </ListGroup>
);
